"use strict";

var _productForm = _interopRequireDefault(require("../components/product-form"));

var _productGallery = _interopRequireDefault(require("../components/product-gallery"));

var _productTabs = _interopRequireDefault(require("../components/product-tabs"));

var _accordion = _interopRequireDefault(require("../components/accordion"));

var _productSwatches = _interopRequireDefault(require("../components/product-swatches"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Template: Product
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */


document.addEventListener('DOMContentLoaded', function () {
  (0, _productForm["default"])({
    container: 'container',
    enableSwatches: true
  }).init();
  (0, _productGallery["default"])().init();
  (0, _accordion["default"])('.accordion').init();
  (0, _productTabs["default"])().init();
  (0, _productSwatches["default"])().init();
});